import { useTranslation } from 'react-i18next';
import { FormControlLabel, Switch } from '@mui/material';

interface MechanicFilterProps {
  hideAbsent: boolean;
  onHideAbsentChange: (hide: boolean) => void;
}

export function MechanicFilter({ hideAbsent, onHideAbsentChange }: MechanicFilterProps) {
  const { t } = useTranslation('calendar');
  return (
    <FormControlLabel
      control={
        <Switch
          size="small"
          checked={hideAbsent}
          onChange={(_event, checked) => { onHideAbsentChange(checked); }}
          inputProps={{ 'aria-label': t('hideAbsent.label') }}
        />
      }
      label={t('hideAbsent.label')}
      slotProps={{ typography: { variant: 'body2' } }}
      sx={{ mr: 0, whiteSpace: 'nowrap' }}
    />
  );
}
